/** Remove apelidos entre parênteses do nome ("(Guga) Luiz" → "Luiz").
 *  Casos comuns vêm do TalentLMS, onde a pessoa cadastra o apelido no
 *  campo first_name. Se o nome inteiro estiver entre parênteses,
 *  preservamos o original para não devolver string vazia. */
export function stripNicknameParens(name: string): string {
  if (!name) return "";
  const stripped = name.replace(/\([^)]*\)/g, "").replace(/\s+/g, " ").trim();
  return stripped || name.trim();
}
